/** Two-letter site locale alias path segment (e.g. `uk`, `fr`). Keep in sync with SFRA `scripts/utils/constants.js`. */
export const LOCALE_ALIAS_PATH_SEGMENT = /^[a-z]{2}$/i;

/** BCP-47 locale ID path segment (e.g. `en-GB`, `fr-FR`). Keep in sync with SFRA `scripts/utils/constants.js`. */
export const LOCALE_ID_PATH_SEGMENT = /^[a-z]{2}-[a-z]{2}$/i;

/**
 * SFRA URL-rules product leaf: `{name-slug}-{PRODUCT_ID}.html`.
 * Capture groups: (1) prefix including trailing `-`, (2) product id.
 * Keep in sync with SFRA hierarchy URL builder leaf format.
 */
export const PRODUCT_HIERARCHY_LEAF_PATTERN = /^(.*-)([A-Za-z0-9]+)\.html$/i;

/** File extension suffix for hierarchy product leaves (SFRA URL rules). */
export const PRODUCT_HIERARCHY_LEAF_SUFFIX = '.html';

/** Stable SCAPI getComponent id for the burger menu embedded content host. */
export const BURGER_MENU_EMBEDDED_HOST_COMPONENT_ID = 'snk-burger-menu';

/** Stable SCAPI getComponent id for the nested burger menu footer embedded host. */
export const BURGER_MENU_FOOTER_EMBEDDED_COMPONENT_ID = 'burger-menu-footer';

/** Must match `component_id` on the global header banner host decorator — renaming detaches BM assignments. */
export const GLOBAL_HEADER_BANNER_COMPONENT_ID = 'global-header-banner';

export const GLOBAL_HEADER_BANNER_REGION_ID = 'banner';
export const GLOBAL_HEADER_APP_BANNER_REGION_ID = 'appBanner';

export const PROMO_BANNER_DEFAULT_BACKGROUND_HEX = '#E5A29D';

export const PROMO_BANNER_DEFAULT_TEXT_HEX = '#000000';

export const PROMO_BANNER_MIN_HEIGHT_PX = 36;

export const PROMO_BANNER_DEFAULT_ROTATION_INTERVAL_MS = 5000;

/** Guards a mis-typed interval. */
export const PROMO_BANNER_MIN_ROTATION_INTERVAL_MS = 2000;
export const PROMO_BANNER_MAX_ROTATION_INTERVAL_MS = 60000;

export const CURALATE_EDGE_ORIGIN = 'https://edge.curalate.com';
export const YOUTUBE_DOMAIN = 'youtube.com';
export const YOUTUBE_NO_COOKIE_DOMAIN = 'youtube-nocookie.com';
export const YOUTUBE_SHORT_DOMAIN = 'youtu.be';
export const YOUTUBE_EMBED_ORIGIN = `https://www.${YOUTUBE_DOMAIN}`;
export const YOUTUBE_NO_COOKIE_ORIGIN = `https://www.${YOUTUBE_NO_COOKIE_DOMAIN}`;
export const YOUTUBE_IMAGE_ORIGIN = 'https://img.youtube.com';
